
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.572 4.029C19.196 2.33 17.55.774 15.847.444 14.809.236 11.915-.02 10 0c-1.914-.02-4.809.235-5.846.443C2.45.774.804 2.33.428 4.029.214 5.059.003 6.463 0 8.379c.003 1.914.214 3.317.428 4.348.376 1.699 2.022 3.255 3.726 3.585.56.112 1.661.238 2.858.328.135.212.282.439.441.68.635.96 1.12 1.63 1.489 2.097.612.777 1.504.777 2.117 0a31.46 31.46 0 001.488-2.098c.16-.24.306-.467.442-.68 1.196-.088 2.298-.215 2.858-.327 1.703-.33 3.35-1.886 3.726-3.585.214-1.03.425-2.434.428-4.349-.003-1.915-.214-3.318-.428-4.349zm-8.468 10.156a.644.644 0 01-.495.496c-.145.023-.341.046-.61.046-.267 0-.464-.022-.608-.046a.644.644 0 01-.496-.496 3.7 3.7 0 01-.047-.61c0-.267.023-.464.047-.608a.644.644 0 01.496-.496c.144-.024.34-.046.609-.047.268 0 .464.023.609.047a.644.644 0 01.495.496c.024.144.047.34.047.609 0 .268-.022.464-.047.609zm2.379-6.398c-.302.426-.754.816-1.423 1.225-.846.522-.982.736-.982 1.156v.166a1.08 1.08 0 01-2.16 0V9.95c0-.495.125-.915.38-1.284.246-.358.616-.676 1.165-1.002 1.011-.595 1.196-.93 1.196-1.373 0-.557-.474-.917-1.208-.917-.805 0-1.329.366-1.557 1.087a1.142 1.142 0 01-1.18.792 1.15 1.15 0 01-.876-.507 1.138 1.138 0 01-.143-.99A3.5 3.5 0 018.06 3.91c.654-.446 1.481-.682 2.39-.682.91 0 1.82.301 2.468.848.665.563 1.032 1.339 1.032 2.185 0 .582-.153 1.08-.467 1.526z","fill":"#E2E8F0"}})])
          )
        }
      }
    